import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { ReferenceHomepage } from './components/ReferenceHomepage';
import { InteriorLayout } from './components/interior/InteriorLayout';
import { RouteEffects } from './components/interior/RouteEffects';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AreasPage from './pages/AreasPage';
import CityPage from './pages/CityPage';
import ProjectsPage from './pages/ProjectsPage';
import EquipmentPage from './pages/EquipmentPage';
import AboutPage from './pages/AboutPage';
import InquiryPage from './pages/InquiryPage';
import ResourcesPage from './pages/ResourcesPage';
import NotFoundPage from './pages/NotFoundPage';
import CareersPage from './pages/CareersPage';
import LegalPage from './pages/LegalPage';
import { GlobalFooter } from './components/GlobalFooter';
import SubcontractorsPage from './pages/SubcontractorsPage';
import SubcontractorResourcesPage from './pages/SubcontractorResourcesPage';
import PrintableFormPage from './pages/PrintableFormPage';
import PortalAuthPage from './pages/PortalAuthPage';
import PasswordHelpPage from './pages/PasswordHelpPage';
import { AuthProvider } from './portal/AuthContext';
import { PortalLayout } from './portal/PortalLayout';
import DashboardPage from './portal/DashboardPage';
import ProfilePage from './portal/ProfilePage';
import DocumentsPage from './portal/DocumentsPage';
import InsurancePage from './portal/InsurancePage';
import FormsPage from './portal/FormsPage';
import SecurityPage from './portal/SecurityPage';
import AdminContractorsPage from './portal/AdminContractorsPage';
import AdminDetailPage from './portal/AdminDetailPage';
import RequirementsPage from './portal/RequirementsPage';
import OurStoryPage from './pages/OurStoryPage';
import './App.css';
import './interior.css';
import './portal.css';
import './responsive.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <RouteEffects />
      <Routes>
        <Route element={<><Outlet /><GlobalFooter /></>}>
        <Route path="/" element={<ReferenceHomepage />} />
        <Route element={<InteriorLayout />}>
          <Route path="services" element={<ServicesPage />} />
          <Route path="services/:slug" element={<ServiceDetailPage />} />
          <Route path="service-areas" element={<AreasPage />} />
          <Route path="service-areas/:slug" element={<CityPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="equipment" element={<EquipmentPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="our-story" element={<OurStoryPage />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="contact" element={<InquiryPage key="contact" />} />
          <Route path="request-a-quote" element={<InquiryPage key="quote" quote />} />
          <Route path="resources" element={<ResourcesPage />} />
          <Route path="privacy-policy" element={<LegalPage documentKey="privacy-policy" />} />
          <Route path="terms-of-use" element={<LegalPage documentKey="terms-of-use" />} />
          <Route path="accessibility" element={<LegalPage documentKey="accessibility" />} />
          <Route path="subcontractors" element={<SubcontractorsPage />} />
          <Route path="subcontractors/register" element={<PortalAuthPage mode="register" />} />
          <Route path="subcontractors/login" element={<PortalAuthPage mode="login" />} />
          <Route path="subcontractors/password-help" element={<PasswordHelpPage />} />
          <Route path="subcontractors/forms" element={<SubcontractorResourcesPage kind="forms" />} />
          <Route path="subcontractors/forms/:form" element={<PrintableFormPage />} />
          <Route path="subcontractors/insurance" element={<SubcontractorResourcesPage kind="insurance" />} />
          <Route path="subcontractors/resources" element={<SubcontractorResourcesPage kind="resources" />} />
          <Route path="admin/setup" element={<PortalAuthPage mode="setup" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        </Route>
        <Route path="portal" element={<PortalLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="insurance" element={<InsurancePage />} />
          <Route path="forms" element={<FormsPage />} />
          <Route path="forms/:form" element={<PrintableFormPage workspace />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="admin" element={<AdminContractorsPage />} />
          <Route path="admin/:id" element={<AdminDetailPage />} />
          <Route path="requirements" element={<RequirementsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}